module.exports = {
    "xspace.client.xform.XImage.xeditorUploadImageImage": "Выгрузить изображения",
    "xspace.client.xform.XImage.xeditorXImageAlign": "Выровнять",
    "xspace.client.xform.XImage.xeditorXImageDeleteImage": "Удалить изображения",
    "xspace.client.xform.XImage.xeditorXImageDownloadImage": "Загрузить изображения",
    "xspace.client.xform.XImage.xeditorXImageImage": "Изображения",
    "xspace.client.xform.XImage.xeditorXImageLeftAlign": "Переместить влево",
    "xspace.client.xform.XImage.xeditorXImageNofloat": "По центру",
    "xspace.client.xform.XImage.xeditorXImageReplaceImage": "Заменить изображения",
    "xspace.client.xform.XImage.xeditorXImageRestoreWidth": "Восстановить исходный размер",
    "xspace.client.xform.XImage.xeditorXImageRightAlign": "Переместить вправо",
    "xspace.client.xform.dateRange.xformDefaultEndDatePlaceholder": "Дата окончания",
    "xspace.client.xform.dateRange.xformDefaultStartDatePlaceholder": "Дата начала",
    "xspace.client.xform.index.xformDefaultSubmitButtonLabel": "Отправить",
    "xspace.client.xform.index.xformUploaderImageFileCheckMessage": "Загрузить не изображение файлы, пожалуйста, повторно загрузить фотографии",
    "xspace.client.xform.insertbar.xeditorInsertbarMenuTitle": "Вставить",
    "xspace.client.xform.insertbar.xeditorInsertbarTool": "Инструменты",
    "xspace.client.xform.upload.xformBatchUploadDefaultLabel": "Загрузить",
    "xspace.client.xform.upload.xformBatchUploadToolTip": "Нажмите Ctrl / Command для пакетной загрузки файлов",
    "xspace.client.xform.upload.xformExampleImageLabel": "Изображение образца",
    "xspace.client.xform.upload.xformFileTemplateLabel": "Шаблон",
    "xspace.client.xform.upload.xformMaxFileNumErrorTip": "Размер загружаемого файла превышает максимальный предел",
    "xspace.client.xform.upload.xformMaxFileSizeErrorTip": "Максимальный размер загружаемого файла:",
    "xspace.client.xform.upload.xformUploadErrorTip": "Ошибка загрузки. Повторите попытку позже."
};